// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ApiDocsRouteImport } from './routes/api-docs'
import { Route as BuildsRouteImport } from './routes/builds'
import { Route as ChangelogRouteImport } from './routes/changelog'
import { Route as CommunityRouteImport } from './routes/community'
import { Route as CompareRouteImport } from './routes/compare'
import { Route as ConfirmRouteImport } from './routes/confirm'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as CoursesRouteImport } from './routes/courses'
import { Route as DeRouteImport } from './routes/de'
import { Route as FrRouteImport } from './routes/fr'
import { Route as FundamentalsRouteImport } from './routes/fundamentals'
import { Route as GlossaryRouteImport } from './routes/glossary'
import { Route as GuidesRouteImport } from './routes/guides'
import { Route as ImprintRouteImport } from './routes/imprint'
import { Route as ItRouteImport } from './routes/it'
import { Route as KnowledgeRouteImport } from './routes/knowledge'
import { Route as LoginRouteImport } from './routes/login'
import { Route as NewsletterRouteImport } from './routes/newsletter'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProgressRouteImport } from './routes/progress'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as SavedRouteImport } from './routes/saved'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ToolsRouteImport } from './routes/tools'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminSectionRouteImport } from './routes/admin.$section'
import { Route as BuildsIndexRouteImport } from './routes/builds.index'
import { Route as BuildsBuildSlugRouteImport } from './routes/builds.$buildSlug'
import { Route as CertificatesCertificateIdRouteImport } from './routes/certificates.$certificateId'
import { Route as ChangelogIndexRouteImport } from './routes/changelog.index'
import { Route as ChangelogEntrySlugRouteImport } from './routes/changelog.$entrySlug'
import { Route as CommunityIndexRouteImport } from './routes/community.index'
import { Route as CommunityTopicsRouteImport } from './routes/community.topics'
import { Route as CompareIndexRouteImport } from './routes/compare.index'
import { Route as CompareComparisonSlugRouteImport } from './routes/compare.$comparisonSlug'
import { Route as CoursesIndexRouteImport } from './routes/courses.index'
import { Route as CoursesCourseSlugRouteImport } from './routes/courses.$courseSlug'
import { Route as DeIndexRouteImport } from './routes/de.index'
import { Route as DeAbmeldenRouteImport } from './routes/de.abmelden'
import { Route as DeAdminRouteImport } from './routes/de.admin'
import { Route as DeAgbRouteImport } from './routes/de.agb'
import { Route as DeApiDocsRouteImport } from './routes/de.api-docs'
import { Route as DeBarrierefreiheitRouteImport } from './routes/de.barrierefreiheit'
import { Route as DeBestaetigenRouteImport } from './routes/de.bestaetigen'
import { Route as DeChangelogRouteImport } from './routes/de.changelog'
import { Route as DeCommunityRouteImport } from './routes/de.community'
import { Route as DeCookiesRouteImport } from './routes/de.cookies'
import { Route as DeDatenschutzRouteImport } from './routes/de.datenschutz'
import { Route as DeEinstellungenRouteImport } from './routes/de.einstellungen'
import { Route as DeFortschrittRouteImport } from './routes/de.fortschritt'
import { Route as DeGespeichertRouteImport } from './routes/de.gespeichert'
import { Route as DeGlossarRouteImport } from './routes/de.glossar'
import { Route as DeGrundlagenRouteImport } from './routes/de.grundlagen'
import { Route as DeImpressumRouteImport } from './routes/de.impressum'
import { Route as DeKontaktRouteImport } from './routes/de.kontakt'
import { Route as DeKurseRouteImport } from './routes/de.kurse'
import { Route as DeLoginRouteImport } from './routes/de.login'
import { Route as DeNewsletterRouteImport } from './routes/de.newsletter'
import { Route as DeOnboardingRouteImport } from './routes/de.onboarding'
import { Route as DePreiseRouteImport } from './routes/de.preise'
import { Route as DeProjekteRouteImport } from './routes/de.projekte'
import { Route as DeRatgeberRouteImport } from './routes/de.ratgeber'
import { Route as DeRegistrierenRouteImport } from './routes/de.registrieren'
import { Route as DeRessourcenRouteImport } from './routes/de.ressourcen'
import { Route as DeSucheRouteImport } from './routes/de.suche'
import { Route as DeToolsRouteImport } from './routes/de.tools'
import { Route as DeUeberRouteImport } from './routes/de.ueber'
import { Route as DeVergleichRouteImport } from './routes/de.vergleich'
import { Route as DeWissenRouteImport } from './routes/de.wissen'
import { Route as FrIndexRouteImport } from './routes/fr.index'
import { Route as FrAProposRouteImport } from './routes/fr.a-propos'
import { Route as FrAccessibiliteRouteImport } from './routes/fr.accessibilite'
import { Route as FrAdminRouteImport } from './routes/fr.admin'
import { Route as FrApiDocsRouteImport } from './routes/fr.api-docs'
import { Route as FrChangelogRouteImport } from './routes/fr.changelog'
import { Route as FrCommunauteRouteImport } from './routes/fr.communaute'
import { Route as FrComparerRouteImport } from './routes/fr.comparer'
import { Route as FrConditionsRouteImport } from './routes/fr.conditions'
import { Route as FrConfidentialiteRouteImport } from './routes/fr.confidentialite'
import { Route as FrConfirmerRouteImport } from './routes/fr.confirmer'
import { Route as FrContactRouteImport } from './routes/fr.contact'
import { Route as FrCookiesRouteImport } from './routes/fr.cookies'
import { Route as FrCoursRouteImport } from './routes/fr.cours'
import { Route as FrDesabonnementRouteImport } from './routes/fr.desabonnement'
import { Route as FrEnregistresRouteImport } from './routes/fr.enregistres'
import { Route as FrFondamentauxRouteImport } from './routes/fr.fondamentaux'
import { Route as FrGlossaireRouteImport } from './routes/fr.glossaire'
import { Route as FrGuidesRouteImport } from './routes/fr.guides'
import { Route as FrInscriptionRouteImport } from './routes/fr.inscription'
import { Route as FrLoginRouteImport } from './routes/fr.login'
import { Route as FrMentionsLegalesRouteImport } from './routes/fr.mentions-legales'
import { Route as FrNewsletterRouteImport } from './routes/fr.newsletter'
import { Route as FrOnboardingRouteImport } from './routes/fr.onboarding'
import { Route as FrOutilsRouteImport } from './routes/fr.outils'
import { Route as FrParametresRouteImport } from './routes/fr.parametres'
import { Route as FrProgressionRouteImport } from './routes/fr.progression'
import { Route as FrProjetsRouteImport } from './routes/fr.projets'
import { Route as FrRechercheRouteImport } from './routes/fr.recherche'
import { Route as FrRessourcesRouteImport } from './routes/fr.ressources'
import { Route as FrSavoirRouteImport } from './routes/fr.savoir'
import { Route as FrTarifsRouteImport } from './routes/fr.tarifs'
import { Route as FundamentalsIndexRouteImport } from './routes/fundamentals.index'
import { Route as FundamentalsFundamentalSlugRouteImport } from './routes/fundamentals.$fundamentalSlug'
import { Route as GlossaryIndexRouteImport } from './routes/glossary.index'
import { Route as GlossaryTermSlugRouteImport } from './routes/glossary.$termSlug'
import { Route as GuidesIndexRouteImport } from './routes/guides.index'
import { Route as GuidesGuideSlugRouteImport } from './routes/guides.$guideSlug'
import { Route as ItIndexRouteImport } from './routes/it.index'
import { Route as ItAccessibilitaRouteImport } from './routes/it.accessibilita'
import { Route as ItAdminRouteImport } from './routes/it.admin'
import { Route as ItApiDocsRouteImport } from './routes/it.api-docs'
import { Route as ItChangelogRouteImport } from './routes/it.changelog'
import { Route as ItChiSiamoRouteImport } from './routes/it.chi-siamo'
import { Route as ItCommunityRouteImport } from './routes/it.community'
import { Route as ItConfermaRouteImport } from './routes/it.conferma'
import { Route as ItConfrontaRouteImport } from './routes/it.confronta'
import { Route as ItContattiRouteImport } from './routes/it.contatti'
import { Route as ItCookiesRouteImport } from './routes/it.cookies'
import { Route as ItCorsiRouteImport } from './routes/it.corsi'
import { Route as ItDisiscrizioneRouteImport } from './routes/it.disiscrizione'
import { Route as ItFondamentiRouteImport } from './routes/it.fondamenti'
import { Route as ItGlossarioRouteImport } from './routes/it.glossario'
import { Route as ItGuideRouteImport } from './routes/it.guide'
import { Route as ItImpostazioniRouteImport } from './routes/it.impostazioni'
import { Route as ItLoginRouteImport } from './routes/it.login'
import { Route as ItNewsletterRouteImport } from './routes/it.newsletter'
import { Route as ItNoteLegaliRouteImport } from './routes/it.note-legali'
import { Route as ItOnboardingRouteImport } from './routes/it.onboarding'
import { Route as ItPrezziRouteImport } from './routes/it.prezzi'
import { Route as ItPrivacyRouteImport } from './routes/it.privacy'
import { Route as ItProgettiRouteImport } from './routes/it.progetti'
import { Route as ItProgressiRouteImport } from './routes/it.progressi'
import { Route as ItRegistrazioneRouteImport } from './routes/it.registrazione'
import { Route as ItRicercaRouteImport } from './routes/it.ricerca'
import { Route as ItRisorseRouteImport } from './routes/it.risorse'
import { Route as ItSalvatiRouteImport } from './routes/it.salvati'
import { Route as ItSapereRouteImport } from './routes/it.sapere'
import { Route as ItStrumentiRouteImport } from './routes/it.strumenti'
import { Route as ItTerminiRouteImport } from './routes/it.termini'
import { Route as KnowledgeIndexRouteImport } from './routes/knowledge.index'
import { Route as KnowledgeArticleSlugRouteImport } from './routes/knowledge.$articleSlug'
import { Route as ResourcesIndexRouteImport } from './routes/resources.index'
import { Route as ResourcesResourceSlugRouteImport } from './routes/resources.$resourceSlug'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SettingsBillingRouteImport } from './routes/settings.billing'
import { Route as SettingsNotificationsRouteImport } from './routes/settings.notifications'
import { Route as SettingsPrivacyRouteImport } from './routes/settings.privacy'
import { Route as SettingsProfileRouteImport } from './routes/settings.profile'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as ToolsToolSlugRouteImport } from './routes/tools.$toolSlug'
import { Route as CommunityPostsPostSlugRouteImport } from './routes/community.posts.$postSlug'
import { Route as CommunityTopicsIndexRouteImport } from './routes/community.topics.index'
import { Route as CommunityTopicsTopicSlugRouteImport } from './routes/community.topics.$topicSlug'
import { Route as CoursesCourseSlugIndexRouteImport } from './routes/courses.$courseSlug.index'
import { Route as CoursesCourseSlugLessonSlugRouteImport } from './routes/courses.$courseSlug.$lessonSlug'
import { Route as DeAdminIndexRouteImport } from './routes/de.admin.index'
import { Route as DeAdminSectionRouteImport } from './routes/de.admin.$section'
import { Route as DeChangelogIndexRouteImport } from './routes/de.changelog.index'
import { Route as DeChangelogEntrySlugRouteImport } from './routes/de.changelog.$entrySlug'
import { Route as DeCommunityIndexRouteImport } from './routes/de.community.index'
import { Route as DeCommunityThemenRouteImport } from './routes/de.community.themen'
import { Route as DeEinstellungenIndexRouteImport } from './routes/de.einstellungen.index'
import { Route as DeEinstellungenAbrechnungRouteImport } from './routes/de.einstellungen.abrechnung'
import { Route as DeEinstellungenBenachrichtigungenRouteImport } from './routes/de.einstellungen.benachrichtigungen'
import { Route as DeEinstellungenDatenschutzRouteImport } from './routes/de.einstellungen.datenschutz'
import { Route as DeEinstellungenProfilRouteImport } from './routes/de.einstellungen.profil'
import { Route as DeGlossarIndexRouteImport } from './routes/de.glossar.index'
import { Route as DeGlossarTermSlugRouteImport } from './routes/de.glossar.$termSlug'
import { Route as DeGrundlagenIndexRouteImport } from './routes/de.grundlagen.index'
import { Route as DeGrundlagenFundamentalSlugRouteImport } from './routes/de.grundlagen.$fundamentalSlug'
import { Route as DeKurseIndexRouteImport } from './routes/de.kurse.index'
import { Route as DeKurseCourseSlugRouteImport } from './routes/de.kurse.$courseSlug'
import { Route as DeProjekteIndexRouteImport } from './routes/de.projekte.index'
import { Route as DeProjekteBuildSlugRouteImport } from './routes/de.projekte.$buildSlug'
import { Route as DeRatgeberIndexRouteImport } from './routes/de.ratgeber.index'
import { Route as DeRatgeberGuideSlugRouteImport } from './routes/de.ratgeber.$guideSlug'
import { Route as DeRessourcenIndexRouteImport } from './routes/de.ressourcen.index'
import { Route as DeRessourcenResourceSlugRouteImport } from './routes/de.ressourcen.$resourceSlug'
import { Route as DeToolsIndexRouteImport } from './routes/de.tools.index'
import { Route as DeToolsToolSlugRouteImport } from './routes/de.tools.$toolSlug'
import { Route as DeVergleichIndexRouteImport } from './routes/de.vergleich.index'
import { Route as DeVergleichComparisonSlugRouteImport } from './routes/de.vergleich.$comparisonSlug'
import { Route as DeWissenIndexRouteImport } from './routes/de.wissen.index'
import { Route as DeWissenArticleSlugRouteImport } from './routes/de.wissen.$articleSlug'
import { Route as DeZertifikateCertificateIdRouteImport } from './routes/de.zertifikate.$certificateId'
import { Route as FrAdminIndexRouteImport } from './routes/fr.admin.index'
import { Route as FrAdminSectionRouteImport } from './routes/fr.admin.$section'
import { Route as FrCertificatsCertificateIdRouteImport } from './routes/fr.certificats.$certificateId'
import { Route as FrChangelogIndexRouteImport } from './routes/fr.changelog.index'
import { Route as FrChangelogEntrySlugRouteImport } from './routes/fr.changelog.$entrySlug'
import { Route as FrCommunauteIndexRouteImport } from './routes/fr.communaute.index'
import { Route as FrCommunauteThemesRouteImport } from './routes/fr.communaute.themes'
import { Route as FrComparerIndexRouteImport } from './routes/fr.comparer.index'
import { Route as FrComparerComparisonSlugRouteImport } from './routes/fr.comparer.$comparisonSlug'
import { Route as FrCoursIndexRouteImport } from './routes/fr.cours.index'
import { Route as FrCoursCourseSlugRouteImport } from './routes/fr.cours.$courseSlug'
import { Route as FrFondamentauxIndexRouteImport } from './routes/fr.fondamentaux.index'
import { Route as FrFondamentauxFundamentalSlugRouteImport } from './routes/fr.fondamentaux.$fundamentalSlug'
import { Route as FrGlossaireIndexRouteImport } from './routes/fr.glossaire.index'
import { Route as FrGlossaireTermSlugRouteImport } from './routes/fr.glossaire.$termSlug'
import { Route as FrGuidesIndexRouteImport } from './routes/fr.guides.index'
import { Route as FrGuidesGuideSlugRouteImport } from './routes/fr.guides.$guideSlug'
import { Route as FrOutilsIndexRouteImport } from './routes/fr.outils.index'
import { Route as FrOutilsToolSlugRouteImport } from './routes/fr.outils.$toolSlug'
import { Route as FrParametresIndexRouteImport } from './routes/fr.parametres.index'
import { Route as FrParametresConfidentialiteRouteImport } from './routes/fr.parametres.confidentialite'
import { Route as FrParametresFacturationRouteImport } from './routes/fr.parametres.facturation'
import { Route as FrParametresNotificationsRouteImport } from './routes/fr.parametres.notifications'
import { Route as FrParametresProfilRouteImport } from './routes/fr.parametres.profil'
import { Route as FrProjetsIndexRouteImport } from './routes/fr.projets.index'
import { Route as FrProjetsBuildSlugRouteImport } from './routes/fr.projets.$buildSlug'
import { Route as FrRessourcesIndexRouteImport } from './routes/fr.ressources.index'
import { Route as FrRessourcesResourceSlugRouteImport } from './routes/fr.ressources.$resourceSlug'
import { Route as FrSavoirIndexRouteImport } from './routes/fr.savoir.index'
import { Route as FrSavoirArticleSlugRouteImport } from './routes/fr.savoir.$articleSlug'
import { Route as ItAdminIndexRouteImport } from './routes/it.admin.index'
import { Route as ItAdminSectionRouteImport } from './routes/it.admin.$section'
import { Route as ItCertificatiCertificateIdRouteImport } from './routes/it.certificati.$certificateId'
import { Route as ItChangelogIndexRouteImport } from './routes/it.changelog.index'
import { Route as ItChangelogEntrySlugRouteImport } from './routes/it.changelog.$entrySlug'
import { Route as ItCommunityIndexRouteImport } from './routes/it.community.index'
import { Route as ItCommunityTemiRouteImport } from './routes/it.community.temi'
import { Route as ItConfrontaIndexRouteImport } from './routes/it.confronta.index'
import { Route as ItConfrontaComparisonSlugRouteImport } from './routes/it.confronta.$comparisonSlug'
import { Route as ItCorsiIndexRouteImport } from './routes/it.corsi.index'
import { Route as ItCorsiCourseSlugRouteImport } from './routes/it.corsi.$courseSlug'
import { Route as ItFondamentiIndexRouteImport } from './routes/it.fondamenti.index'
import { Route as ItFondamentiFundamentalSlugRouteImport } from './routes/it.fondamenti.$fundamentalSlug'
import { Route as ItGlossarioIndexRouteImport } from './routes/it.glossario.index'
import { Route as ItGlossarioTermSlugRouteImport } from './routes/it.glossario.$termSlug'
import { Route as ItGuideIndexRouteImport } from './routes/it.guide.index'
import { Route as ItGuideGuideSlugRouteImport } from './routes/it.guide.$guideSlug'
import { Route as ItImpostazioniIndexRouteImport } from './routes/it.impostazioni.index'
import { Route as ItImpostazioniAbbonamentoRouteImport } from './routes/it.impostazioni.abbonamento'
import { Route as ItImpostazioniNotificheRouteImport } from './routes/it.impostazioni.notifiche'
import { Route as ItImpostazioniPrivacyRouteImport } from './routes/it.impostazioni.privacy'
import { Route as ItImpostazioniProfiloRouteImport } from './routes/it.impostazioni.profilo'
import { Route as ItProgettiIndexRouteImport } from './routes/it.progetti.index'
import { Route as ItProgettiBuildSlugRouteImport } from './routes/it.progetti.$buildSlug'
import { Route as ItRisorseIndexRouteImport } from './routes/it.risorse.index'
import { Route as ItRisorseResourceSlugRouteImport } from './routes/it.risorse.$resourceSlug'
import { Route as ItSapereIndexRouteImport } from './routes/it.sapere.index'
import { Route as ItSapereArticleSlugRouteImport } from './routes/it.sapere.$articleSlug'
import { Route as ItStrumentiIndexRouteImport } from './routes/it.strumenti.index'
import { Route as ItStrumentiToolSlugRouteImport } from './routes/it.strumenti.$toolSlug'
import { Route as DeCommunityBeitraegePostSlugRouteImport } from './routes/de.community.beitraege.$postSlug'
import { Route as DeCommunityThemenIndexRouteImport } from './routes/de.community.themen.index'
import { Route as DeCommunityThemenTopicSlugRouteImport } from './routes/de.community.themen.$topicSlug'
import { Route as DeKurseCourseSlugIndexRouteImport } from './routes/de.kurse.$courseSlug.index'
import { Route as DeKurseCourseSlugLessonSlugRouteImport } from './routes/de.kurse.$courseSlug.$lessonSlug'
import { Route as FrCommunautePublicationsPostSlugRouteImport } from './routes/fr.communaute.publications.$postSlug'
import { Route as FrCommunauteThemesIndexRouteImport } from './routes/fr.communaute.themes.index'
import { Route as FrCommunauteThemesTopicSlugRouteImport } from './routes/fr.communaute.themes.$topicSlug'
import { Route as FrCoursCourseSlugIndexRouteImport } from './routes/fr.cours.$courseSlug.index'
import { Route as FrCoursCourseSlugLessonSlugRouteImport } from './routes/fr.cours.$courseSlug.$lessonSlug'
import { Route as ItCommunityPostPostSlugRouteImport } from './routes/it.community.post.$postSlug'
import { Route as ItCommunityTemiIndexRouteImport } from './routes/it.community.temi.index'
import { Route as ItCommunityTemiTopicSlugRouteImport } from './routes/it.community.temi.$topicSlug'
import { Route as ItCorsiCourseSlugIndexRouteImport } from './routes/it.corsi.$courseSlug.index'
import { Route as ItCorsiCourseSlugLessonSlugRouteImport } from './routes/it.corsi.$courseSlug.$lessonSlug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AccessibilityRoute = AccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const ApiDocsRoute = ApiDocsRouteImport.update({
            id: '/api-docs',path: '/api-docs',getParentRoute: () => rootRouteImport
          })
const BuildsRoute = BuildsRouteImport.update({
            id: '/builds',path: '/builds',getParentRoute: () => rootRouteImport
          })
const ChangelogRoute = ChangelogRouteImport.update({
            id: '/changelog',path: '/changelog',getParentRoute: () => rootRouteImport
          })
const CommunityRoute = CommunityRouteImport.update({
            id: '/community',path: '/community',getParentRoute: () => rootRouteImport
          })
const CompareRoute = CompareRouteImport.update({
            id: '/compare',path: '/compare',getParentRoute: () => rootRouteImport
          })
const ConfirmRoute = ConfirmRouteImport.update({
            id: '/confirm',path: '/confirm',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const CoursesRoute = CoursesRouteImport.update({
            id: '/courses',path: '/courses',getParentRoute: () => rootRouteImport
          })
const DeRoute = DeRouteImport.update({
            id: '/de',path: '/de',getParentRoute: () => rootRouteImport
          })
const FrRoute = FrRouteImport.update({
            id: '/fr',path: '/fr',getParentRoute: () => rootRouteImport
          })
const FundamentalsRoute = FundamentalsRouteImport.update({
            id: '/fundamentals',path: '/fundamentals',getParentRoute: () => rootRouteImport
          })
const GlossaryRoute = GlossaryRouteImport.update({
            id: '/glossary',path: '/glossary',getParentRoute: () => rootRouteImport
          })
const GuidesRoute = GuidesRouteImport.update({
            id: '/guides',path: '/guides',getParentRoute: () => rootRouteImport
          })
const ImprintRoute = ImprintRouteImport.update({
            id: '/imprint',path: '/imprint',getParentRoute: () => rootRouteImport
          })
const ItRoute = ItRouteImport.update({
            id: '/it',path: '/it',getParentRoute: () => rootRouteImport
          })
const KnowledgeRoute = KnowledgeRouteImport.update({
            id: '/knowledge',path: '/knowledge',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const NewsletterRoute = NewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProgressRoute = ProgressRouteImport.update({
            id: '/progress',path: '/progress',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const SavedRoute = SavedRouteImport.update({
            id: '/saved',path: '/saved',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ToolsRoute = ToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminSectionRoute = AdminSectionRouteImport.update({
            id: '/$section',path: '/$section',getParentRoute: () => AdminRoute
          })
const BuildsIndexRoute = BuildsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BuildsRoute
          })
const BuildsBuildSlugRoute = BuildsBuildSlugRouteImport.update({
            id: '/$buildSlug',path: '/$buildSlug',getParentRoute: () => BuildsRoute
          })
const CertificatesCertificateIdRoute = CertificatesCertificateIdRouteImport.update({
            id: '/certificates/$certificateId',path: '/certificates/$certificateId',getParentRoute: () => rootRouteImport
          })
const ChangelogIndexRoute = ChangelogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ChangelogRoute
          })
const ChangelogEntrySlugRoute = ChangelogEntrySlugRouteImport.update({
            id: '/$entrySlug',path: '/$entrySlug',getParentRoute: () => ChangelogRoute
          })
const CommunityIndexRoute = CommunityIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CommunityRoute
          })
const CommunityTopicsRoute = CommunityTopicsRouteImport.update({
            id: '/topics',path: '/topics',getParentRoute: () => CommunityRoute
          })
const CompareIndexRoute = CompareIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CompareRoute
          })
const CompareComparisonSlugRoute = CompareComparisonSlugRouteImport.update({
            id: '/$comparisonSlug',path: '/$comparisonSlug',getParentRoute: () => CompareRoute
          })
const CoursesIndexRoute = CoursesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CoursesRoute
          })
const CoursesCourseSlugRoute = CoursesCourseSlugRouteImport.update({
            id: '/$courseSlug',path: '/$courseSlug',getParentRoute: () => CoursesRoute
          })
const DeIndexRoute = DeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeRoute
          })
const DeAbmeldenRoute = DeAbmeldenRouteImport.update({
            id: '/abmelden',path: '/abmelden',getParentRoute: () => DeRoute
          })
const DeAdminRoute = DeAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => DeRoute
          })
const DeAgbRoute = DeAgbRouteImport.update({
            id: '/agb',path: '/agb',getParentRoute: () => DeRoute
          })
const DeApiDocsRoute = DeApiDocsRouteImport.update({
            id: '/api-docs',path: '/api-docs',getParentRoute: () => DeRoute
          })
const DeBarrierefreiheitRoute = DeBarrierefreiheitRouteImport.update({
            id: '/barrierefreiheit',path: '/barrierefreiheit',getParentRoute: () => DeRoute
          })
const DeBestaetigenRoute = DeBestaetigenRouteImport.update({
            id: '/bestaetigen',path: '/bestaetigen',getParentRoute: () => DeRoute
          })
const DeChangelogRoute = DeChangelogRouteImport.update({
            id: '/changelog',path: '/changelog',getParentRoute: () => DeRoute
          })
const DeCommunityRoute = DeCommunityRouteImport.update({
            id: '/community',path: '/community',getParentRoute: () => DeRoute
          })
const DeCookiesRoute = DeCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => DeRoute
          })
const DeDatenschutzRoute = DeDatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => DeRoute
          })
const DeEinstellungenRoute = DeEinstellungenRouteImport.update({
            id: '/einstellungen',path: '/einstellungen',getParentRoute: () => DeRoute
          })
const DeFortschrittRoute = DeFortschrittRouteImport.update({
            id: '/fortschritt',path: '/fortschritt',getParentRoute: () => DeRoute
          })
const DeGespeichertRoute = DeGespeichertRouteImport.update({
            id: '/gespeichert',path: '/gespeichert',getParentRoute: () => DeRoute
          })
const DeGlossarRoute = DeGlossarRouteImport.update({
            id: '/glossar',path: '/glossar',getParentRoute: () => DeRoute
          })
const DeGrundlagenRoute = DeGrundlagenRouteImport.update({
            id: '/grundlagen',path: '/grundlagen',getParentRoute: () => DeRoute
          })
const DeImpressumRoute = DeImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => DeRoute
          })
const DeKontaktRoute = DeKontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => DeRoute
          })
const DeKurseRoute = DeKurseRouteImport.update({
            id: '/kurse',path: '/kurse',getParentRoute: () => DeRoute
          })
const DeLoginRoute = DeLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => DeRoute
          })
const DeNewsletterRoute = DeNewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => DeRoute
          })
const DeOnboardingRoute = DeOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => DeRoute
          })
const DePreiseRoute = DePreiseRouteImport.update({
            id: '/preise',path: '/preise',getParentRoute: () => DeRoute
          })
const DeProjekteRoute = DeProjekteRouteImport.update({
            id: '/projekte',path: '/projekte',getParentRoute: () => DeRoute
          })
const DeRatgeberRoute = DeRatgeberRouteImport.update({
            id: '/ratgeber',path: '/ratgeber',getParentRoute: () => DeRoute
          })
const DeRegistrierenRoute = DeRegistrierenRouteImport.update({
            id: '/registrieren',path: '/registrieren',getParentRoute: () => DeRoute
          })
const DeRessourcenRoute = DeRessourcenRouteImport.update({
            id: '/ressourcen',path: '/ressourcen',getParentRoute: () => DeRoute
          })
const DeSucheRoute = DeSucheRouteImport.update({
            id: '/suche',path: '/suche',getParentRoute: () => DeRoute
          })
const DeToolsRoute = DeToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => DeRoute
          })
const DeUeberRoute = DeUeberRouteImport.update({
            id: '/ueber',path: '/ueber',getParentRoute: () => DeRoute
          })
const DeVergleichRoute = DeVergleichRouteImport.update({
            id: '/vergleich',path: '/vergleich',getParentRoute: () => DeRoute
          })
const DeWissenRoute = DeWissenRouteImport.update({
            id: '/wissen',path: '/wissen',getParentRoute: () => DeRoute
          })
const FrIndexRoute = FrIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrRoute
          })
const FrAProposRoute = FrAProposRouteImport.update({
            id: '/a-propos',path: '/a-propos',getParentRoute: () => FrRoute
          })
const FrAccessibiliteRoute = FrAccessibiliteRouteImport.update({
            id: '/accessibilite',path: '/accessibilite',getParentRoute: () => FrRoute
          })
const FrAdminRoute = FrAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => FrRoute
          })
const FrApiDocsRoute = FrApiDocsRouteImport.update({
            id: '/api-docs',path: '/api-docs',getParentRoute: () => FrRoute
          })
const FrChangelogRoute = FrChangelogRouteImport.update({
            id: '/changelog',path: '/changelog',getParentRoute: () => FrRoute
          })
const FrCommunauteRoute = FrCommunauteRouteImport.update({
            id: '/communaute',path: '/communaute',getParentRoute: () => FrRoute
          })
const FrComparerRoute = FrComparerRouteImport.update({
            id: '/comparer',path: '/comparer',getParentRoute: () => FrRoute
          })
const FrConditionsRoute = FrConditionsRouteImport.update({
            id: '/conditions',path: '/conditions',getParentRoute: () => FrRoute
          })
const FrConfidentialiteRoute = FrConfidentialiteRouteImport.update({
            id: '/confidentialite',path: '/confidentialite',getParentRoute: () => FrRoute
          })
const FrConfirmerRoute = FrConfirmerRouteImport.update({
            id: '/confirmer',path: '/confirmer',getParentRoute: () => FrRoute
          })
const FrContactRoute = FrContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => FrRoute
          })
const FrCookiesRoute = FrCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => FrRoute
          })
const FrCoursRoute = FrCoursRouteImport.update({
            id: '/cours',path: '/cours',getParentRoute: () => FrRoute
          })
const FrDesabonnementRoute = FrDesabonnementRouteImport.update({
            id: '/desabonnement',path: '/desabonnement',getParentRoute: () => FrRoute
          })
const FrEnregistresRoute = FrEnregistresRouteImport.update({
            id: '/enregistres',path: '/enregistres',getParentRoute: () => FrRoute
          })
const FrFondamentauxRoute = FrFondamentauxRouteImport.update({
            id: '/fondamentaux',path: '/fondamentaux',getParentRoute: () => FrRoute
          })
const FrGlossaireRoute = FrGlossaireRouteImport.update({
            id: '/glossaire',path: '/glossaire',getParentRoute: () => FrRoute
          })
const FrGuidesRoute = FrGuidesRouteImport.update({
            id: '/guides',path: '/guides',getParentRoute: () => FrRoute
          })
const FrInscriptionRoute = FrInscriptionRouteImport.update({
            id: '/inscription',path: '/inscription',getParentRoute: () => FrRoute
          })
const FrLoginRoute = FrLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => FrRoute
          })
const FrMentionsLegalesRoute = FrMentionsLegalesRouteImport.update({
            id: '/mentions-legales',path: '/mentions-legales',getParentRoute: () => FrRoute
          })
const FrNewsletterRoute = FrNewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => FrRoute
          })
const FrOnboardingRoute = FrOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => FrRoute
          })
const FrOutilsRoute = FrOutilsRouteImport.update({
            id: '/outils',path: '/outils',getParentRoute: () => FrRoute
          })
const FrParametresRoute = FrParametresRouteImport.update({
            id: '/parametres',path: '/parametres',getParentRoute: () => FrRoute
          })
const FrProgressionRoute = FrProgressionRouteImport.update({
            id: '/progression',path: '/progression',getParentRoute: () => FrRoute
          })
const FrProjetsRoute = FrProjetsRouteImport.update({
            id: '/projets',path: '/projets',getParentRoute: () => FrRoute
          })
const FrRechercheRoute = FrRechercheRouteImport.update({
            id: '/recherche',path: '/recherche',getParentRoute: () => FrRoute
          })
const FrRessourcesRoute = FrRessourcesRouteImport.update({
            id: '/ressources',path: '/ressources',getParentRoute: () => FrRoute
          })
const FrSavoirRoute = FrSavoirRouteImport.update({
            id: '/savoir',path: '/savoir',getParentRoute: () => FrRoute
          })
const FrTarifsRoute = FrTarifsRouteImport.update({
            id: '/tarifs',path: '/tarifs',getParentRoute: () => FrRoute
          })
const FundamentalsIndexRoute = FundamentalsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FundamentalsRoute
          })
const FundamentalsFundamentalSlugRoute = FundamentalsFundamentalSlugRouteImport.update({
            id: '/$fundamentalSlug',path: '/$fundamentalSlug',getParentRoute: () => FundamentalsRoute
          })
const GlossaryIndexRoute = GlossaryIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GlossaryRoute
          })
const GlossaryTermSlugRoute = GlossaryTermSlugRouteImport.update({
            id: '/$termSlug',path: '/$termSlug',getParentRoute: () => GlossaryRoute
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GuidesRoute
          })
const GuidesGuideSlugRoute = GuidesGuideSlugRouteImport.update({
            id: '/$guideSlug',path: '/$guideSlug',getParentRoute: () => GuidesRoute
          })
const ItIndexRoute = ItIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItRoute
          })
const ItAccessibilitaRoute = ItAccessibilitaRouteImport.update({
            id: '/accessibilita',path: '/accessibilita',getParentRoute: () => ItRoute
          })
const ItAdminRoute = ItAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => ItRoute
          })
const ItApiDocsRoute = ItApiDocsRouteImport.update({
            id: '/api-docs',path: '/api-docs',getParentRoute: () => ItRoute
          })
const ItChangelogRoute = ItChangelogRouteImport.update({
            id: '/changelog',path: '/changelog',getParentRoute: () => ItRoute
          })
const ItChiSiamoRoute = ItChiSiamoRouteImport.update({
            id: '/chi-siamo',path: '/chi-siamo',getParentRoute: () => ItRoute
          })
const ItCommunityRoute = ItCommunityRouteImport.update({
            id: '/community',path: '/community',getParentRoute: () => ItRoute
          })
const ItConfermaRoute = ItConfermaRouteImport.update({
            id: '/conferma',path: '/conferma',getParentRoute: () => ItRoute
          })
const ItConfrontaRoute = ItConfrontaRouteImport.update({
            id: '/confronta',path: '/confronta',getParentRoute: () => ItRoute
          })
const ItContattiRoute = ItContattiRouteImport.update({
            id: '/contatti',path: '/contatti',getParentRoute: () => ItRoute
          })
const ItCookiesRoute = ItCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => ItRoute
          })
const ItCorsiRoute = ItCorsiRouteImport.update({
            id: '/corsi',path: '/corsi',getParentRoute: () => ItRoute
          })
const ItDisiscrizioneRoute = ItDisiscrizioneRouteImport.update({
            id: '/disiscrizione',path: '/disiscrizione',getParentRoute: () => ItRoute
          })
const ItFondamentiRoute = ItFondamentiRouteImport.update({
            id: '/fondamenti',path: '/fondamenti',getParentRoute: () => ItRoute
          })
const ItGlossarioRoute = ItGlossarioRouteImport.update({
            id: '/glossario',path: '/glossario',getParentRoute: () => ItRoute
          })
const ItGuideRoute = ItGuideRouteImport.update({
            id: '/guide',path: '/guide',getParentRoute: () => ItRoute
          })
const ItImpostazioniRoute = ItImpostazioniRouteImport.update({
            id: '/impostazioni',path: '/impostazioni',getParentRoute: () => ItRoute
          })
const ItLoginRoute = ItLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => ItRoute
          })
const ItNewsletterRoute = ItNewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => ItRoute
          })
const ItNoteLegaliRoute = ItNoteLegaliRouteImport.update({
            id: '/note-legali',path: '/note-legali',getParentRoute: () => ItRoute
          })
const ItOnboardingRoute = ItOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => ItRoute
          })
const ItPrezziRoute = ItPrezziRouteImport.update({
            id: '/prezzi',path: '/prezzi',getParentRoute: () => ItRoute
          })
const ItPrivacyRoute = ItPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => ItRoute
          })
const ItProgettiRoute = ItProgettiRouteImport.update({
            id: '/progetti',path: '/progetti',getParentRoute: () => ItRoute
          })
const ItProgressiRoute = ItProgressiRouteImport.update({
            id: '/progressi',path: '/progressi',getParentRoute: () => ItRoute
          })
const ItRegistrazioneRoute = ItRegistrazioneRouteImport.update({
            id: '/registrazione',path: '/registrazione',getParentRoute: () => ItRoute
          })
const ItRicercaRoute = ItRicercaRouteImport.update({
            id: '/ricerca',path: '/ricerca',getParentRoute: () => ItRoute
          })
const ItRisorseRoute = ItRisorseRouteImport.update({
            id: '/risorse',path: '/risorse',getParentRoute: () => ItRoute
          })
const ItSalvatiRoute = ItSalvatiRouteImport.update({
            id: '/salvati',path: '/salvati',getParentRoute: () => ItRoute
          })
const ItSapereRoute = ItSapereRouteImport.update({
            id: '/sapere',path: '/sapere',getParentRoute: () => ItRoute
          })
const ItStrumentiRoute = ItStrumentiRouteImport.update({
            id: '/strumenti',path: '/strumenti',getParentRoute: () => ItRoute
          })
const ItTerminiRoute = ItTerminiRouteImport.update({
            id: '/termini',path: '/termini',getParentRoute: () => ItRoute
          })
const KnowledgeIndexRoute = KnowledgeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => KnowledgeRoute
          })
const KnowledgeArticleSlugRoute = KnowledgeArticleSlugRouteImport.update({
            id: '/$articleSlug',path: '/$articleSlug',getParentRoute: () => KnowledgeRoute
          })
const ResourcesIndexRoute = ResourcesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ResourcesRoute
          })
const ResourcesResourceSlugRoute = ResourcesResourceSlugRouteImport.update({
            id: '/$resourceSlug',path: '/$resourceSlug',getParentRoute: () => ResourcesRoute
          })
const SettingsIndexRoute = SettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SettingsRoute
          })
const SettingsBillingRoute = SettingsBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => SettingsRoute
          })
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => SettingsRoute
          })
const SettingsPrivacyRoute = SettingsPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => SettingsRoute
          })
const SettingsProfileRoute = SettingsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => SettingsRoute
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ToolsRoute
          })
const ToolsToolSlugRoute = ToolsToolSlugRouteImport.update({
            id: '/$toolSlug',path: '/$toolSlug',getParentRoute: () => ToolsRoute
          })
const CommunityPostsPostSlugRoute = CommunityPostsPostSlugRouteImport.update({
            id: '/posts/$postSlug',path: '/posts/$postSlug',getParentRoute: () => CommunityRoute
          })
const CommunityTopicsIndexRoute = CommunityTopicsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CommunityTopicsRoute
          })
const CommunityTopicsTopicSlugRoute = CommunityTopicsTopicSlugRouteImport.update({
            id: '/$topicSlug',path: '/$topicSlug',getParentRoute: () => CommunityTopicsRoute
          })
const CoursesCourseSlugIndexRoute = CoursesCourseSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CoursesCourseSlugRoute
          })
const CoursesCourseSlugLessonSlugRoute = CoursesCourseSlugLessonSlugRouteImport.update({
            id: '/$lessonSlug',path: '/$lessonSlug',getParentRoute: () => CoursesCourseSlugRoute
          })
const DeAdminIndexRoute = DeAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeAdminRoute
          })
const DeAdminSectionRoute = DeAdminSectionRouteImport.update({
            id: '/$section',path: '/$section',getParentRoute: () => DeAdminRoute
          })
const DeChangelogIndexRoute = DeChangelogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeChangelogRoute
          })
const DeChangelogEntrySlugRoute = DeChangelogEntrySlugRouteImport.update({
            id: '/$entrySlug',path: '/$entrySlug',getParentRoute: () => DeChangelogRoute
          })
const DeCommunityIndexRoute = DeCommunityIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeCommunityRoute
          })
const DeCommunityThemenRoute = DeCommunityThemenRouteImport.update({
            id: '/themen',path: '/themen',getParentRoute: () => DeCommunityRoute
          })
const DeEinstellungenIndexRoute = DeEinstellungenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeEinstellungenRoute
          })
const DeEinstellungenAbrechnungRoute = DeEinstellungenAbrechnungRouteImport.update({
            id: '/abrechnung',path: '/abrechnung',getParentRoute: () => DeEinstellungenRoute
          })
const DeEinstellungenBenachrichtigungenRoute = DeEinstellungenBenachrichtigungenRouteImport.update({
            id: '/benachrichtigungen',path: '/benachrichtigungen',getParentRoute: () => DeEinstellungenRoute
          })
const DeEinstellungenDatenschutzRoute = DeEinstellungenDatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => DeEinstellungenRoute
          })
const DeEinstellungenProfilRoute = DeEinstellungenProfilRouteImport.update({
            id: '/profil',path: '/profil',getParentRoute: () => DeEinstellungenRoute
          })
const DeGlossarIndexRoute = DeGlossarIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeGlossarRoute
          })
const DeGlossarTermSlugRoute = DeGlossarTermSlugRouteImport.update({
            id: '/$termSlug',path: '/$termSlug',getParentRoute: () => DeGlossarRoute
          })
const DeGrundlagenIndexRoute = DeGrundlagenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeGrundlagenRoute
          })
const DeGrundlagenFundamentalSlugRoute = DeGrundlagenFundamentalSlugRouteImport.update({
            id: '/$fundamentalSlug',path: '/$fundamentalSlug',getParentRoute: () => DeGrundlagenRoute
          })
const DeKurseIndexRoute = DeKurseIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeKurseRoute
          })
const DeKurseCourseSlugRoute = DeKurseCourseSlugRouteImport.update({
            id: '/$courseSlug',path: '/$courseSlug',getParentRoute: () => DeKurseRoute
          })
const DeProjekteIndexRoute = DeProjekteIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeProjekteRoute
          })
const DeProjekteBuildSlugRoute = DeProjekteBuildSlugRouteImport.update({
            id: '/$buildSlug',path: '/$buildSlug',getParentRoute: () => DeProjekteRoute
          })
const DeRatgeberIndexRoute = DeRatgeberIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeRatgeberRoute
          })
const DeRatgeberGuideSlugRoute = DeRatgeberGuideSlugRouteImport.update({
            id: '/$guideSlug',path: '/$guideSlug',getParentRoute: () => DeRatgeberRoute
          })
const DeRessourcenIndexRoute = DeRessourcenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeRessourcenRoute
          })
const DeRessourcenResourceSlugRoute = DeRessourcenResourceSlugRouteImport.update({
            id: '/$resourceSlug',path: '/$resourceSlug',getParentRoute: () => DeRessourcenRoute
          })
const DeToolsIndexRoute = DeToolsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeToolsRoute
          })
const DeToolsToolSlugRoute = DeToolsToolSlugRouteImport.update({
            id: '/$toolSlug',path: '/$toolSlug',getParentRoute: () => DeToolsRoute
          })
const DeVergleichIndexRoute = DeVergleichIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeVergleichRoute
          })
const DeVergleichComparisonSlugRoute = DeVergleichComparisonSlugRouteImport.update({
            id: '/$comparisonSlug',path: '/$comparisonSlug',getParentRoute: () => DeVergleichRoute
          })
const DeWissenIndexRoute = DeWissenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeWissenRoute
          })
const DeWissenArticleSlugRoute = DeWissenArticleSlugRouteImport.update({
            id: '/$articleSlug',path: '/$articleSlug',getParentRoute: () => DeWissenRoute
          })
const DeZertifikateCertificateIdRoute = DeZertifikateCertificateIdRouteImport.update({
            id: '/zertifikate/$certificateId',path: '/zertifikate/$certificateId',getParentRoute: () => DeRoute
          })
const FrAdminIndexRoute = FrAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrAdminRoute
          })
const FrAdminSectionRoute = FrAdminSectionRouteImport.update({
            id: '/$section',path: '/$section',getParentRoute: () => FrAdminRoute
          })
const FrCertificatsCertificateIdRoute = FrCertificatsCertificateIdRouteImport.update({
            id: '/certificats/$certificateId',path: '/certificats/$certificateId',getParentRoute: () => FrRoute
          })
const FrChangelogIndexRoute = FrChangelogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrChangelogRoute
          })
const FrChangelogEntrySlugRoute = FrChangelogEntrySlugRouteImport.update({
            id: '/$entrySlug',path: '/$entrySlug',getParentRoute: () => FrChangelogRoute
          })
const FrCommunauteIndexRoute = FrCommunauteIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrCommunauteRoute
          })
const FrCommunauteThemesRoute = FrCommunauteThemesRouteImport.update({
            id: '/themes',path: '/themes',getParentRoute: () => FrCommunauteRoute
          })
const FrComparerIndexRoute = FrComparerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrComparerRoute
          })
const FrComparerComparisonSlugRoute = FrComparerComparisonSlugRouteImport.update({
            id: '/$comparisonSlug',path: '/$comparisonSlug',getParentRoute: () => FrComparerRoute
          })
const FrCoursIndexRoute = FrCoursIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrCoursRoute
          })
const FrCoursCourseSlugRoute = FrCoursCourseSlugRouteImport.update({
            id: '/$courseSlug',path: '/$courseSlug',getParentRoute: () => FrCoursRoute
          })
const FrFondamentauxIndexRoute = FrFondamentauxIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrFondamentauxRoute
          })
const FrFondamentauxFundamentalSlugRoute = FrFondamentauxFundamentalSlugRouteImport.update({
            id: '/$fundamentalSlug',path: '/$fundamentalSlug',getParentRoute: () => FrFondamentauxRoute
          })
const FrGlossaireIndexRoute = FrGlossaireIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrGlossaireRoute
          })
const FrGlossaireTermSlugRoute = FrGlossaireTermSlugRouteImport.update({
            id: '/$termSlug',path: '/$termSlug',getParentRoute: () => FrGlossaireRoute
          })
const FrGuidesIndexRoute = FrGuidesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrGuidesRoute
          })
const FrGuidesGuideSlugRoute = FrGuidesGuideSlugRouteImport.update({
            id: '/$guideSlug',path: '/$guideSlug',getParentRoute: () => FrGuidesRoute
          })
const FrOutilsIndexRoute = FrOutilsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrOutilsRoute
          })
const FrOutilsToolSlugRoute = FrOutilsToolSlugRouteImport.update({
            id: '/$toolSlug',path: '/$toolSlug',getParentRoute: () => FrOutilsRoute
          })
const FrParametresIndexRoute = FrParametresIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrParametresRoute
          })
const FrParametresConfidentialiteRoute = FrParametresConfidentialiteRouteImport.update({
            id: '/confidentialite',path: '/confidentialite',getParentRoute: () => FrParametresRoute
          })
const FrParametresFacturationRoute = FrParametresFacturationRouteImport.update({
            id: '/facturation',path: '/facturation',getParentRoute: () => FrParametresRoute
          })
const FrParametresNotificationsRoute = FrParametresNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => FrParametresRoute
          })
const FrParametresProfilRoute = FrParametresProfilRouteImport.update({
            id: '/profil',path: '/profil',getParentRoute: () => FrParametresRoute
          })
const FrProjetsIndexRoute = FrProjetsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrProjetsRoute
          })
const FrProjetsBuildSlugRoute = FrProjetsBuildSlugRouteImport.update({
            id: '/$buildSlug',path: '/$buildSlug',getParentRoute: () => FrProjetsRoute
          })
const FrRessourcesIndexRoute = FrRessourcesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrRessourcesRoute
          })
const FrRessourcesResourceSlugRoute = FrRessourcesResourceSlugRouteImport.update({
            id: '/$resourceSlug',path: '/$resourceSlug',getParentRoute: () => FrRessourcesRoute
          })
const FrSavoirIndexRoute = FrSavoirIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrSavoirRoute
          })
const FrSavoirArticleSlugRoute = FrSavoirArticleSlugRouteImport.update({
            id: '/$articleSlug',path: '/$articleSlug',getParentRoute: () => FrSavoirRoute
          })
const ItAdminIndexRoute = ItAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItAdminRoute
          })
const ItAdminSectionRoute = ItAdminSectionRouteImport.update({
            id: '/$section',path: '/$section',getParentRoute: () => ItAdminRoute
          })
const ItCertificatiCertificateIdRoute = ItCertificatiCertificateIdRouteImport.update({
            id: '/certificati/$certificateId',path: '/certificati/$certificateId',getParentRoute: () => ItRoute
          })
const ItChangelogIndexRoute = ItChangelogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItChangelogRoute
          })
const ItChangelogEntrySlugRoute = ItChangelogEntrySlugRouteImport.update({
            id: '/$entrySlug',path: '/$entrySlug',getParentRoute: () => ItChangelogRoute
          })
const ItCommunityIndexRoute = ItCommunityIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItCommunityRoute
          })
const ItCommunityTemiRoute = ItCommunityTemiRouteImport.update({
            id: '/temi',path: '/temi',getParentRoute: () => ItCommunityRoute
          })
const ItConfrontaIndexRoute = ItConfrontaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItConfrontaRoute
          })
const ItConfrontaComparisonSlugRoute = ItConfrontaComparisonSlugRouteImport.update({
            id: '/$comparisonSlug',path: '/$comparisonSlug',getParentRoute: () => ItConfrontaRoute
          })
const ItCorsiIndexRoute = ItCorsiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItCorsiRoute
          })
const ItCorsiCourseSlugRoute = ItCorsiCourseSlugRouteImport.update({
            id: '/$courseSlug',path: '/$courseSlug',getParentRoute: () => ItCorsiRoute
          })
const ItFondamentiIndexRoute = ItFondamentiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItFondamentiRoute
          })
const ItFondamentiFundamentalSlugRoute = ItFondamentiFundamentalSlugRouteImport.update({
            id: '/$fundamentalSlug',path: '/$fundamentalSlug',getParentRoute: () => ItFondamentiRoute
          })
const ItGlossarioIndexRoute = ItGlossarioIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItGlossarioRoute
          })
const ItGlossarioTermSlugRoute = ItGlossarioTermSlugRouteImport.update({
            id: '/$termSlug',path: '/$termSlug',getParentRoute: () => ItGlossarioRoute
          })
const ItGuideIndexRoute = ItGuideIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItGuideRoute
          })
const ItGuideGuideSlugRoute = ItGuideGuideSlugRouteImport.update({
            id: '/$guideSlug',path: '/$guideSlug',getParentRoute: () => ItGuideRoute
          })
const ItImpostazioniIndexRoute = ItImpostazioniIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItImpostazioniRoute
          })
const ItImpostazioniAbbonamentoRoute = ItImpostazioniAbbonamentoRouteImport.update({
            id: '/abbonamento',path: '/abbonamento',getParentRoute: () => ItImpostazioniRoute
          })
const ItImpostazioniNotificheRoute = ItImpostazioniNotificheRouteImport.update({
            id: '/notifiche',path: '/notifiche',getParentRoute: () => ItImpostazioniRoute
          })
const ItImpostazioniPrivacyRoute = ItImpostazioniPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => ItImpostazioniRoute
          })
const ItImpostazioniProfiloRoute = ItImpostazioniProfiloRouteImport.update({
            id: '/profilo',path: '/profilo',getParentRoute: () => ItImpostazioniRoute
          })
const ItProgettiIndexRoute = ItProgettiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItProgettiRoute
          })
const ItProgettiBuildSlugRoute = ItProgettiBuildSlugRouteImport.update({
            id: '/$buildSlug',path: '/$buildSlug',getParentRoute: () => ItProgettiRoute
          })
const ItRisorseIndexRoute = ItRisorseIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItRisorseRoute
          })
const ItRisorseResourceSlugRoute = ItRisorseResourceSlugRouteImport.update({
            id: '/$resourceSlug',path: '/$resourceSlug',getParentRoute: () => ItRisorseRoute
          })
const ItSapereIndexRoute = ItSapereIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItSapereRoute
          })
const ItSapereArticleSlugRoute = ItSapereArticleSlugRouteImport.update({
            id: '/$articleSlug',path: '/$articleSlug',getParentRoute: () => ItSapereRoute
          })
const ItStrumentiIndexRoute = ItStrumentiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItStrumentiRoute
          })
const ItStrumentiToolSlugRoute = ItStrumentiToolSlugRouteImport.update({
            id: '/$toolSlug',path: '/$toolSlug',getParentRoute: () => ItStrumentiRoute
          })
const DeCommunityBeitraegePostSlugRoute = DeCommunityBeitraegePostSlugRouteImport.update({
            id: '/beitraege/$postSlug',path: '/beitraege/$postSlug',getParentRoute: () => DeCommunityRoute
          })
const DeCommunityThemenIndexRoute = DeCommunityThemenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeCommunityThemenRoute
          })
const DeCommunityThemenTopicSlugRoute = DeCommunityThemenTopicSlugRouteImport.update({
            id: '/$topicSlug',path: '/$topicSlug',getParentRoute: () => DeCommunityThemenRoute
          })
const DeKurseCourseSlugIndexRoute = DeKurseCourseSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DeKurseCourseSlugRoute
          })
const DeKurseCourseSlugLessonSlugRoute = DeKurseCourseSlugLessonSlugRouteImport.update({
            id: '/$lessonSlug',path: '/$lessonSlug',getParentRoute: () => DeKurseCourseSlugRoute
          })
const FrCommunautePublicationsPostSlugRoute = FrCommunautePublicationsPostSlugRouteImport.update({
            id: '/publications/$postSlug',path: '/publications/$postSlug',getParentRoute: () => FrCommunauteRoute
          })
const FrCommunauteThemesIndexRoute = FrCommunauteThemesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrCommunauteThemesRoute
          })
const FrCommunauteThemesTopicSlugRoute = FrCommunauteThemesTopicSlugRouteImport.update({
            id: '/$topicSlug',path: '/$topicSlug',getParentRoute: () => FrCommunauteThemesRoute
          })
const FrCoursCourseSlugIndexRoute = FrCoursCourseSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FrCoursCourseSlugRoute
          })
const FrCoursCourseSlugLessonSlugRoute = FrCoursCourseSlugLessonSlugRouteImport.update({
            id: '/$lessonSlug',path: '/$lessonSlug',getParentRoute: () => FrCoursCourseSlugRoute
          })
const ItCommunityPostPostSlugRoute = ItCommunityPostPostSlugRouteImport.update({
            id: '/post/$postSlug',path: '/post/$postSlug',getParentRoute: () => ItCommunityRoute
          })
const ItCommunityTemiIndexRoute = ItCommunityTemiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItCommunityTemiRoute
          })
const ItCommunityTemiTopicSlugRoute = ItCommunityTemiTopicSlugRouteImport.update({
            id: '/$topicSlug',path: '/$topicSlug',getParentRoute: () => ItCommunityTemiRoute
          })
const ItCorsiCourseSlugIndexRoute = ItCorsiCourseSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItCorsiCourseSlugRoute
          })
const ItCorsiCourseSlugLessonSlugRoute = ItCorsiCourseSlugLessonSlugRouteImport.update({
            id: '/$lessonSlug',path: '/$lessonSlug',getParentRoute: () => ItCorsiCourseSlugRoute
          })





const AdminRouteChildren = {
  AdminSectionRoute: AdminSectionRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const BuildsRouteChildren = {
  BuildsBuildSlugRoute: BuildsBuildSlugRoute,BuildsIndexRoute: BuildsIndexRoute
}

const BuildsRouteWithChildren = BuildsRoute._addFileChildren(BuildsRouteChildren)




const ChangelogRouteChildren = {
  ChangelogEntrySlugRoute: ChangelogEntrySlugRoute,ChangelogIndexRoute: ChangelogIndexRoute
}

const ChangelogRouteWithChildren = ChangelogRoute._addFileChildren(ChangelogRouteChildren)




const CommunityTopicsRouteChildren = {
  CommunityTopicsTopicSlugRoute: CommunityTopicsTopicSlugRoute,CommunityTopicsIndexRoute: CommunityTopicsIndexRoute
}

const CommunityTopicsRouteWithChildren = CommunityTopicsRoute._addFileChildren(CommunityTopicsRouteChildren)



const CommunityRouteChildren = {
  CommunityTopicsRoute: CommunityTopicsRouteWithChildren,CommunityIndexRoute: CommunityIndexRoute,CommunityPostsPostSlugRoute: CommunityPostsPostSlugRoute
}

const CommunityRouteWithChildren = CommunityRoute._addFileChildren(CommunityRouteChildren)




const CompareRouteChildren = {
  CompareComparisonSlugRoute: CompareComparisonSlugRoute,CompareIndexRoute: CompareIndexRoute
}

const CompareRouteWithChildren = CompareRoute._addFileChildren(CompareRouteChildren)




const CoursesCourseSlugRouteChildren = {
  CoursesCourseSlugLessonSlugRoute: CoursesCourseSlugLessonSlugRoute,CoursesCourseSlugIndexRoute: CoursesCourseSlugIndexRoute
}

const CoursesCourseSlugRouteWithChildren = CoursesCourseSlugRoute._addFileChildren(CoursesCourseSlugRouteChildren)



const CoursesRouteChildren = {
  CoursesCourseSlugRoute: CoursesCourseSlugRouteWithChildren,CoursesIndexRoute: CoursesIndexRoute
}

const CoursesRouteWithChildren = CoursesRoute._addFileChildren(CoursesRouteChildren)




const DeAdminRouteChildren = {
  DeAdminSectionRoute: DeAdminSectionRoute,DeAdminIndexRoute: DeAdminIndexRoute
}

const DeAdminRouteWithChildren = DeAdminRoute._addFileChildren(DeAdminRouteChildren)




const DeChangelogRouteChildren = {
  DeChangelogEntrySlugRoute: DeChangelogEntrySlugRoute,DeChangelogIndexRoute: DeChangelogIndexRoute
}

const DeChangelogRouteWithChildren = DeChangelogRoute._addFileChildren(DeChangelogRouteChildren)




const DeCommunityThemenRouteChildren = {
  DeCommunityThemenTopicSlugRoute: DeCommunityThemenTopicSlugRoute,DeCommunityThemenIndexRoute: DeCommunityThemenIndexRoute
}

const DeCommunityThemenRouteWithChildren = DeCommunityThemenRoute._addFileChildren(DeCommunityThemenRouteChildren)



const DeCommunityRouteChildren = {
  DeCommunityThemenRoute: DeCommunityThemenRouteWithChildren,DeCommunityIndexRoute: DeCommunityIndexRoute,DeCommunityBeitraegePostSlugRoute: DeCommunityBeitraegePostSlugRoute
}

const DeCommunityRouteWithChildren = DeCommunityRoute._addFileChildren(DeCommunityRouteChildren)




const DeEinstellungenRouteChildren = {
  DeEinstellungenAbrechnungRoute: DeEinstellungenAbrechnungRoute,DeEinstellungenBenachrichtigungenRoute: DeEinstellungenBenachrichtigungenRoute,DeEinstellungenDatenschutzRoute: DeEinstellungenDatenschutzRoute,DeEinstellungenProfilRoute: DeEinstellungenProfilRoute,DeEinstellungenIndexRoute: DeEinstellungenIndexRoute
}

const DeEinstellungenRouteWithChildren = DeEinstellungenRoute._addFileChildren(DeEinstellungenRouteChildren)




const DeGlossarRouteChildren = {
  DeGlossarTermSlugRoute: DeGlossarTermSlugRoute,DeGlossarIndexRoute: DeGlossarIndexRoute
}

const DeGlossarRouteWithChildren = DeGlossarRoute._addFileChildren(DeGlossarRouteChildren)




const DeGrundlagenRouteChildren = {
  DeGrundlagenFundamentalSlugRoute: DeGrundlagenFundamentalSlugRoute,DeGrundlagenIndexRoute: DeGrundlagenIndexRoute
}

const DeGrundlagenRouteWithChildren = DeGrundlagenRoute._addFileChildren(DeGrundlagenRouteChildren)




const DeKurseCourseSlugRouteChildren = {
  DeKurseCourseSlugLessonSlugRoute: DeKurseCourseSlugLessonSlugRoute,DeKurseCourseSlugIndexRoute: DeKurseCourseSlugIndexRoute
}

const DeKurseCourseSlugRouteWithChildren = DeKurseCourseSlugRoute._addFileChildren(DeKurseCourseSlugRouteChildren)



const DeKurseRouteChildren = {
  DeKurseCourseSlugRoute: DeKurseCourseSlugRouteWithChildren,DeKurseIndexRoute: DeKurseIndexRoute
}

const DeKurseRouteWithChildren = DeKurseRoute._addFileChildren(DeKurseRouteChildren)




const DeProjekteRouteChildren = {
  DeProjekteBuildSlugRoute: DeProjekteBuildSlugRoute,DeProjekteIndexRoute: DeProjekteIndexRoute
}

const DeProjekteRouteWithChildren = DeProjekteRoute._addFileChildren(DeProjekteRouteChildren)




const DeRatgeberRouteChildren = {
  DeRatgeberGuideSlugRoute: DeRatgeberGuideSlugRoute,DeRatgeberIndexRoute: DeRatgeberIndexRoute
}

const DeRatgeberRouteWithChildren = DeRatgeberRoute._addFileChildren(DeRatgeberRouteChildren)




const DeRessourcenRouteChildren = {
  DeRessourcenResourceSlugRoute: DeRessourcenResourceSlugRoute,DeRessourcenIndexRoute: DeRessourcenIndexRoute
}

const DeRessourcenRouteWithChildren = DeRessourcenRoute._addFileChildren(DeRessourcenRouteChildren)




const DeToolsRouteChildren = {
  DeToolsToolSlugRoute: DeToolsToolSlugRoute,DeToolsIndexRoute: DeToolsIndexRoute
}

const DeToolsRouteWithChildren = DeToolsRoute._addFileChildren(DeToolsRouteChildren)




const DeVergleichRouteChildren = {
  DeVergleichComparisonSlugRoute: DeVergleichComparisonSlugRoute,DeVergleichIndexRoute: DeVergleichIndexRoute
}

const DeVergleichRouteWithChildren = DeVergleichRoute._addFileChildren(DeVergleichRouteChildren)




const DeWissenRouteChildren = {
  DeWissenArticleSlugRoute: DeWissenArticleSlugRoute,DeWissenIndexRoute: DeWissenIndexRoute
}

const DeWissenRouteWithChildren = DeWissenRoute._addFileChildren(DeWissenRouteChildren)



const DeRouteChildren = {
  DeAbmeldenRoute: DeAbmeldenRoute,DeAdminRoute: DeAdminRouteWithChildren,DeAgbRoute: DeAgbRoute,DeApiDocsRoute: DeApiDocsRoute,DeBarrierefreiheitRoute: DeBarrierefreiheitRoute,DeBestaetigenRoute: DeBestaetigenRoute,DeChangelogRoute: DeChangelogRouteWithChildren,DeCommunityRoute: DeCommunityRouteWithChildren,DeCookiesRoute: DeCookiesRoute,DeDatenschutzRoute: DeDatenschutzRoute,DeEinstellungenRoute: DeEinstellungenRouteWithChildren,DeFortschrittRoute: DeFortschrittRoute,DeGespeichertRoute: DeGespeichertRoute,DeGlossarRoute: DeGlossarRouteWithChildren,DeGrundlagenRoute: DeGrundlagenRouteWithChildren,DeImpressumRoute: DeImpressumRoute,DeKontaktRoute: DeKontaktRoute,DeKurseRoute: DeKurseRouteWithChildren,DeLoginRoute: DeLoginRoute,DeNewsletterRoute: DeNewsletterRoute,DeOnboardingRoute: DeOnboardingRoute,DePreiseRoute: DePreiseRoute,DeProjekteRoute: DeProjekteRouteWithChildren,DeRatgeberRoute: DeRatgeberRouteWithChildren,DeRegistrierenRoute: DeRegistrierenRoute,DeRessourcenRoute: DeRessourcenRouteWithChildren,DeSucheRoute: DeSucheRoute,DeToolsRoute: DeToolsRouteWithChildren,DeUeberRoute: DeUeberRoute,DeVergleichRoute: DeVergleichRouteWithChildren,DeWissenRoute: DeWissenRouteWithChildren,DeIndexRoute: DeIndexRoute,DeZertifikateCertificateIdRoute: DeZertifikateCertificateIdRoute
}

const DeRouteWithChildren = DeRoute._addFileChildren(DeRouteChildren)




const FrAdminRouteChildren = {
  FrAdminSectionRoute: FrAdminSectionRoute,FrAdminIndexRoute: FrAdminIndexRoute
}

const FrAdminRouteWithChildren = FrAdminRoute._addFileChildren(FrAdminRouteChildren)




const FrChangelogRouteChildren = {
  FrChangelogEntrySlugRoute: FrChangelogEntrySlugRoute,FrChangelogIndexRoute: FrChangelogIndexRoute
}

const FrChangelogRouteWithChildren = FrChangelogRoute._addFileChildren(FrChangelogRouteChildren)




const FrCommunauteThemesRouteChildren = {
  FrCommunauteThemesTopicSlugRoute: FrCommunauteThemesTopicSlugRoute,FrCommunauteThemesIndexRoute: FrCommunauteThemesIndexRoute
}

const FrCommunauteThemesRouteWithChildren = FrCommunauteThemesRoute._addFileChildren(FrCommunauteThemesRouteChildren)



const FrCommunauteRouteChildren = {
  FrCommunauteThemesRoute: FrCommunauteThemesRouteWithChildren,FrCommunauteIndexRoute: FrCommunauteIndexRoute,FrCommunautePublicationsPostSlugRoute: FrCommunautePublicationsPostSlugRoute
}

const FrCommunauteRouteWithChildren = FrCommunauteRoute._addFileChildren(FrCommunauteRouteChildren)




const FrComparerRouteChildren = {
  FrComparerComparisonSlugRoute: FrComparerComparisonSlugRoute,FrComparerIndexRoute: FrComparerIndexRoute
}

const FrComparerRouteWithChildren = FrComparerRoute._addFileChildren(FrComparerRouteChildren)




const FrCoursCourseSlugRouteChildren = {
  FrCoursCourseSlugLessonSlugRoute: FrCoursCourseSlugLessonSlugRoute,FrCoursCourseSlugIndexRoute: FrCoursCourseSlugIndexRoute
}

const FrCoursCourseSlugRouteWithChildren = FrCoursCourseSlugRoute._addFileChildren(FrCoursCourseSlugRouteChildren)



const FrCoursRouteChildren = {
  FrCoursCourseSlugRoute: FrCoursCourseSlugRouteWithChildren,FrCoursIndexRoute: FrCoursIndexRoute
}

const FrCoursRouteWithChildren = FrCoursRoute._addFileChildren(FrCoursRouteChildren)




const FrFondamentauxRouteChildren = {
  FrFondamentauxFundamentalSlugRoute: FrFondamentauxFundamentalSlugRoute,FrFondamentauxIndexRoute: FrFondamentauxIndexRoute
}

const FrFondamentauxRouteWithChildren = FrFondamentauxRoute._addFileChildren(FrFondamentauxRouteChildren)




const FrGlossaireRouteChildren = {
  FrGlossaireTermSlugRoute: FrGlossaireTermSlugRoute,FrGlossaireIndexRoute: FrGlossaireIndexRoute
}

const FrGlossaireRouteWithChildren = FrGlossaireRoute._addFileChildren(FrGlossaireRouteChildren)




const FrGuidesRouteChildren = {
  FrGuidesGuideSlugRoute: FrGuidesGuideSlugRoute,FrGuidesIndexRoute: FrGuidesIndexRoute
}

const FrGuidesRouteWithChildren = FrGuidesRoute._addFileChildren(FrGuidesRouteChildren)




const FrOutilsRouteChildren = {
  FrOutilsToolSlugRoute: FrOutilsToolSlugRoute,FrOutilsIndexRoute: FrOutilsIndexRoute
}

const FrOutilsRouteWithChildren = FrOutilsRoute._addFileChildren(FrOutilsRouteChildren)




const FrParametresRouteChildren = {
  FrParametresConfidentialiteRoute: FrParametresConfidentialiteRoute,FrParametresFacturationRoute: FrParametresFacturationRoute,FrParametresNotificationsRoute: FrParametresNotificationsRoute,FrParametresProfilRoute: FrParametresProfilRoute,FrParametresIndexRoute: FrParametresIndexRoute
}

const FrParametresRouteWithChildren = FrParametresRoute._addFileChildren(FrParametresRouteChildren)




const FrProjetsRouteChildren = {
  FrProjetsBuildSlugRoute: FrProjetsBuildSlugRoute,FrProjetsIndexRoute: FrProjetsIndexRoute
}

const FrProjetsRouteWithChildren = FrProjetsRoute._addFileChildren(FrProjetsRouteChildren)




const FrRessourcesRouteChildren = {
  FrRessourcesResourceSlugRoute: FrRessourcesResourceSlugRoute,FrRessourcesIndexRoute: FrRessourcesIndexRoute
}

const FrRessourcesRouteWithChildren = FrRessourcesRoute._addFileChildren(FrRessourcesRouteChildren)




const FrSavoirRouteChildren = {
  FrSavoirArticleSlugRoute: FrSavoirArticleSlugRoute,FrSavoirIndexRoute: FrSavoirIndexRoute
}

const FrSavoirRouteWithChildren = FrSavoirRoute._addFileChildren(FrSavoirRouteChildren)



const FrRouteChildren = {
  FrAProposRoute: FrAProposRoute,FrAccessibiliteRoute: FrAccessibiliteRoute,FrAdminRoute: FrAdminRouteWithChildren,FrApiDocsRoute: FrApiDocsRoute,FrChangelogRoute: FrChangelogRouteWithChildren,FrCommunauteRoute: FrCommunauteRouteWithChildren,FrComparerRoute: FrComparerRouteWithChildren,FrConditionsRoute: FrConditionsRoute,FrConfidentialiteRoute: FrConfidentialiteRoute,FrConfirmerRoute: FrConfirmerRoute,FrContactRoute: FrContactRoute,FrCookiesRoute: FrCookiesRoute,FrCoursRoute: FrCoursRouteWithChildren,FrDesabonnementRoute: FrDesabonnementRoute,FrEnregistresRoute: FrEnregistresRoute,FrFondamentauxRoute: FrFondamentauxRouteWithChildren,FrGlossaireRoute: FrGlossaireRouteWithChildren,FrGuidesRoute: FrGuidesRouteWithChildren,FrInscriptionRoute: FrInscriptionRoute,FrLoginRoute: FrLoginRoute,FrMentionsLegalesRoute: FrMentionsLegalesRoute,FrNewsletterRoute: FrNewsletterRoute,FrOnboardingRoute: FrOnboardingRoute,FrOutilsRoute: FrOutilsRouteWithChildren,FrParametresRoute: FrParametresRouteWithChildren,FrProgressionRoute: FrProgressionRoute,FrProjetsRoute: FrProjetsRouteWithChildren,FrRechercheRoute: FrRechercheRoute,FrRessourcesRoute: FrRessourcesRouteWithChildren,FrSavoirRoute: FrSavoirRouteWithChildren,FrTarifsRoute: FrTarifsRoute,FrIndexRoute: FrIndexRoute,FrCertificatsCertificateIdRoute: FrCertificatsCertificateIdRoute
}

const FrRouteWithChildren = FrRoute._addFileChildren(FrRouteChildren)




const FundamentalsRouteChildren = {
  FundamentalsFundamentalSlugRoute: FundamentalsFundamentalSlugRoute,FundamentalsIndexRoute: FundamentalsIndexRoute
}

const FundamentalsRouteWithChildren = FundamentalsRoute._addFileChildren(FundamentalsRouteChildren)




const GlossaryRouteChildren = {
  GlossaryTermSlugRoute: GlossaryTermSlugRoute,GlossaryIndexRoute: GlossaryIndexRoute
}

const GlossaryRouteWithChildren = GlossaryRoute._addFileChildren(GlossaryRouteChildren)




const GuidesRouteChildren = {
  GuidesGuideSlugRoute: GuidesGuideSlugRoute,GuidesIndexRoute: GuidesIndexRoute
}

const GuidesRouteWithChildren = GuidesRoute._addFileChildren(GuidesRouteChildren)




const ItAdminRouteChildren = {
  ItAdminSectionRoute: ItAdminSectionRoute,ItAdminIndexRoute: ItAdminIndexRoute
}

const ItAdminRouteWithChildren = ItAdminRoute._addFileChildren(ItAdminRouteChildren)




const ItChangelogRouteChildren = {
  ItChangelogEntrySlugRoute: ItChangelogEntrySlugRoute,ItChangelogIndexRoute: ItChangelogIndexRoute
}

const ItChangelogRouteWithChildren = ItChangelogRoute._addFileChildren(ItChangelogRouteChildren)




const ItCommunityTemiRouteChildren = {
  ItCommunityTemiTopicSlugRoute: ItCommunityTemiTopicSlugRoute,ItCommunityTemiIndexRoute: ItCommunityTemiIndexRoute
}

const ItCommunityTemiRouteWithChildren = ItCommunityTemiRoute._addFileChildren(ItCommunityTemiRouteChildren)



const ItCommunityRouteChildren = {
  ItCommunityTemiRoute: ItCommunityTemiRouteWithChildren,ItCommunityIndexRoute: ItCommunityIndexRoute,ItCommunityPostPostSlugRoute: ItCommunityPostPostSlugRoute
}

const ItCommunityRouteWithChildren = ItCommunityRoute._addFileChildren(ItCommunityRouteChildren)




const ItConfrontaRouteChildren = {
  ItConfrontaComparisonSlugRoute: ItConfrontaComparisonSlugRoute,ItConfrontaIndexRoute: ItConfrontaIndexRoute
}

const ItConfrontaRouteWithChildren = ItConfrontaRoute._addFileChildren(ItConfrontaRouteChildren)




const ItCorsiCourseSlugRouteChildren = {
  ItCorsiCourseSlugLessonSlugRoute: ItCorsiCourseSlugLessonSlugRoute,ItCorsiCourseSlugIndexRoute: ItCorsiCourseSlugIndexRoute
}

const ItCorsiCourseSlugRouteWithChildren = ItCorsiCourseSlugRoute._addFileChildren(ItCorsiCourseSlugRouteChildren)



const ItCorsiRouteChildren = {
  ItCorsiCourseSlugRoute: ItCorsiCourseSlugRouteWithChildren,ItCorsiIndexRoute: ItCorsiIndexRoute
}

const ItCorsiRouteWithChildren = ItCorsiRoute._addFileChildren(ItCorsiRouteChildren)




const ItFondamentiRouteChildren = {
  ItFondamentiFundamentalSlugRoute: ItFondamentiFundamentalSlugRoute,ItFondamentiIndexRoute: ItFondamentiIndexRoute
}

const ItFondamentiRouteWithChildren = ItFondamentiRoute._addFileChildren(ItFondamentiRouteChildren)




const ItGlossarioRouteChildren = {
  ItGlossarioTermSlugRoute: ItGlossarioTermSlugRoute,ItGlossarioIndexRoute: ItGlossarioIndexRoute
}

const ItGlossarioRouteWithChildren = ItGlossarioRoute._addFileChildren(ItGlossarioRouteChildren)




const ItGuideRouteChildren = {
  ItGuideGuideSlugRoute: ItGuideGuideSlugRoute,ItGuideIndexRoute: ItGuideIndexRoute
}

const ItGuideRouteWithChildren = ItGuideRoute._addFileChildren(ItGuideRouteChildren)




const ItImpostazioniRouteChildren = {
  ItImpostazioniAbbonamentoRoute: ItImpostazioniAbbonamentoRoute,ItImpostazioniNotificheRoute: ItImpostazioniNotificheRoute,ItImpostazioniPrivacyRoute: ItImpostazioniPrivacyRoute,ItImpostazioniProfiloRoute: ItImpostazioniProfiloRoute,ItImpostazioniIndexRoute: ItImpostazioniIndexRoute
}

const ItImpostazioniRouteWithChildren = ItImpostazioniRoute._addFileChildren(ItImpostazioniRouteChildren)




const ItProgettiRouteChildren = {
  ItProgettiBuildSlugRoute: ItProgettiBuildSlugRoute,ItProgettiIndexRoute: ItProgettiIndexRoute
}

const ItProgettiRouteWithChildren = ItProgettiRoute._addFileChildren(ItProgettiRouteChildren)




const ItRisorseRouteChildren = {
  ItRisorseResourceSlugRoute: ItRisorseResourceSlugRoute,ItRisorseIndexRoute: ItRisorseIndexRoute
}

const ItRisorseRouteWithChildren = ItRisorseRoute._addFileChildren(ItRisorseRouteChildren)




const ItSapereRouteChildren = {
  ItSapereArticleSlugRoute: ItSapereArticleSlugRoute,ItSapereIndexRoute: ItSapereIndexRoute
}

const ItSapereRouteWithChildren = ItSapereRoute._addFileChildren(ItSapereRouteChildren)




const ItStrumentiRouteChildren = {
  ItStrumentiToolSlugRoute: ItStrumentiToolSlugRoute,ItStrumentiIndexRoute: ItStrumentiIndexRoute
}

const ItStrumentiRouteWithChildren = ItStrumentiRoute._addFileChildren(ItStrumentiRouteChildren)



const ItRouteChildren = {
  ItAccessibilitaRoute: ItAccessibilitaRoute,ItAdminRoute: ItAdminRouteWithChildren,ItApiDocsRoute: ItApiDocsRoute,ItChangelogRoute: ItChangelogRouteWithChildren,ItChiSiamoRoute: ItChiSiamoRoute,ItCommunityRoute: ItCommunityRouteWithChildren,ItConfermaRoute: ItConfermaRoute,ItConfrontaRoute: ItConfrontaRouteWithChildren,ItContattiRoute: ItContattiRoute,ItCookiesRoute: ItCookiesRoute,ItCorsiRoute: ItCorsiRouteWithChildren,ItDisiscrizioneRoute: ItDisiscrizioneRoute,ItFondamentiRoute: ItFondamentiRouteWithChildren,ItGlossarioRoute: ItGlossarioRouteWithChildren,ItGuideRoute: ItGuideRouteWithChildren,ItImpostazioniRoute: ItImpostazioniRouteWithChildren,ItLoginRoute: ItLoginRoute,ItNewsletterRoute: ItNewsletterRoute,ItNoteLegaliRoute: ItNoteLegaliRoute,ItOnboardingRoute: ItOnboardingRoute,ItPrezziRoute: ItPrezziRoute,ItPrivacyRoute: ItPrivacyRoute,ItProgettiRoute: ItProgettiRouteWithChildren,ItProgressiRoute: ItProgressiRoute,ItRegistrazioneRoute: ItRegistrazioneRoute,ItRicercaRoute: ItRicercaRoute,ItRisorseRoute: ItRisorseRouteWithChildren,ItSalvatiRoute: ItSalvatiRoute,ItSapereRoute: ItSapereRouteWithChildren,ItStrumentiRoute: ItStrumentiRouteWithChildren,ItTerminiRoute: ItTerminiRoute,ItIndexRoute: ItIndexRoute,ItCertificatiCertificateIdRoute: ItCertificatiCertificateIdRoute
}

const ItRouteWithChildren = ItRoute._addFileChildren(ItRouteChildren)




const KnowledgeRouteChildren = {
  KnowledgeArticleSlugRoute: KnowledgeArticleSlugRoute,KnowledgeIndexRoute: KnowledgeIndexRoute
}

const KnowledgeRouteWithChildren = KnowledgeRoute._addFileChildren(KnowledgeRouteChildren)




const ResourcesRouteChildren = {
  ResourcesResourceSlugRoute: ResourcesResourceSlugRoute,ResourcesIndexRoute: ResourcesIndexRoute
}

const ResourcesRouteWithChildren = ResourcesRoute._addFileChildren(ResourcesRouteChildren)




const SettingsRouteChildren = {
  SettingsBillingRoute: SettingsBillingRoute,SettingsNotificationsRoute: SettingsNotificationsRoute,SettingsPrivacyRoute: SettingsPrivacyRoute,SettingsProfileRoute: SettingsProfileRoute,SettingsIndexRoute: SettingsIndexRoute
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(SettingsRouteChildren)




const ToolsRouteChildren = {
  ToolsToolSlugRoute: ToolsToolSlugRoute,ToolsIndexRoute: ToolsIndexRoute
}

const ToolsRouteWithChildren = ToolsRoute._addFileChildren(ToolsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccessibilityRoute: AccessibilityRoute,AdminRoute: AdminRouteWithChildren,ApiDocsRoute: ApiDocsRoute,BuildsRoute: BuildsRouteWithChildren,ChangelogRoute: ChangelogRouteWithChildren,CommunityRoute: CommunityRouteWithChildren,CompareRoute: CompareRouteWithChildren,ConfirmRoute: ConfirmRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,CoursesRoute: CoursesRouteWithChildren,DeRoute: DeRouteWithChildren,FrRoute: FrRouteWithChildren,FundamentalsRoute: FundamentalsRouteWithChildren,GlossaryRoute: GlossaryRouteWithChildren,GuidesRoute: GuidesRouteWithChildren,ImprintRoute: ImprintRoute,ItRoute: ItRouteWithChildren,KnowledgeRoute: KnowledgeRouteWithChildren,LoginRoute: LoginRoute,NewsletterRoute: NewsletterRoute,OnboardingRoute: OnboardingRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ProgressRoute: ProgressRoute,RegisterRoute: RegisterRoute,ResourcesRoute: ResourcesRouteWithChildren,SavedRoute: SavedRoute,SearchRoute: SearchRoute,SettingsRoute: SettingsRouteWithChildren,TermsRoute: TermsRoute,ToolsRoute: ToolsRouteWithChildren,UnsubscribeRoute: UnsubscribeRoute,CertificatesCertificateIdRoute: CertificatesCertificateIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)